import React from 'react';
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { Map, MapLayers, MapMarker, MapMarkerLayer, MapMarkerLayerTooltip, MapTileLayer } from '@progress/kendo-react-map';
import { useNavigate, useParams } from 'react-router-dom';
import { TicketApi } from '../../../../redux/api/TicketApi';
import * as svg from '@progress/kendo-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import { isMobile } from 'react-device-detect';

const MapView: React.FC = () => {
    const { ticketId } = useParams();
    const navigate = useNavigate();
    const [stage, setStage] = React.useState(isMobile ? 'FULLSCREEN' : 'DEFAULT');
    const { data: ticket } = TicketApi.useGetTicketDetailsQuery({ ticketId: Number(ticketId) });
    const tileUrl = e => `https://${e.subdomain}.tile.openstreetmap.org/${e.zoom}/${e.x}/${e.y}.png`;
    const tileSubdomains = ['a', 'b', 'c'];
    const attribution = '&copy; <a href="https://osm.org/copyright">OpenStreetMap contributors</a>';
    const markers = [{
        latlng: [ticket?.Latitude, ticket?.Longitude],
        name: ticket?.Address_Html
    }];
    const renderMarkerTooltip = props => <> <div dangerouslySetInnerHTML={{ __html: props.dataItem.name }}></div><div>({props.location.toString()})</div></>;
    const height = stage === 'FULLSCREEN' ? '90vh' : '580px';
    if (!ticket) return null;


    return (
        <Window onStageChange={(s) => setStage(s.state)} stage={stage} minimizeButton={() => null} modal={true} className='cool-window' title={ticket.Company_Name + ' - ' + ticket.Address_Name} onClose={() => { navigate('/ticket/' + ticketId) }} initialHeight={720} initialWidth={1000}>

            <Map className='map-view' center={[ticket?.Latitude, ticket?.Longitude]} zoom={17} style={{ height: height }}>
                {/* <MapMarker position={{ lat: 37.7749, lng: -122.4194 }} /> */}
                <MapLayers>
                    <MapTileLayer urlTemplate={tileUrl} subdomains={tileSubdomains} attribution={attribution} />
                    <MapMarkerLayer data={markers} locationField="latlng" titleField="name">
                        <MapMarkerLayerTooltip render={renderMarkerTooltip} />
                    </MapMarkerLayer>
                </MapLayers>
            </Map>
            <WindowActionsBar>
                <Button themeColor='primary' size='large' onClick={(e) => navigate(`/ticket/${ticketId}`)}>Close</Button>
            </WindowActionsBar>
        </Window>
    );
};

export default MapView;